export default __webpack_public_path__ + "static/media/Water.b74325d0.svg";